import { render, staticRenderFns } from "./NewOrderRow.vue?vue&type=template&id=8c5f99b2"
import script from "./NewOrderRow.vue?vue&type=script&lang=js"
export * from "./NewOrderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports